import { PurchaseReturnStatusEnum } from "./return-status-enum";

export const purchaseReturnStatusLabels = {
  [PurchaseReturnStatusEnum.NONE]: "Tidak Diretur",
  [PurchaseReturnStatusEnum.PARTIALLY_RETURNED]: "Diretur Sebagian",
  [PurchaseReturnStatusEnum.FULLY_RETURNED]: "Diretur Penuh",
};
